import { useContext } from 'react';

import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useHelmet, LinkTag } from '@thd-nucleus/thd-helmet';

export const useImagePreload = ({
  enableDeFeature, imageType, media, pageType
}) => {
  const { channel } = useContext(ExperienceContext);
  const { image: primaryImage, images = [] } = media || {};

  const productMetaDataHandler = () => {
    if (!enableDeFeature || imageType !== 'IMAGE') return [];

    const filteredImage = images?.find((image) => image?.type === imageType);
    if (!filteredImage) return [];

    const imageSize = pageType === 'pep' && channel === 'mobile'
      ? '300'
      : '600';
    const getImageUrl = (image) => image?.url?.replace(/<SIZE>/ig, imageSize);
    const imgUrl = getImageUrl(filteredImage);
    const primaryImageUrl = getImageUrl(primaryImage);

    // Skip primary image, as this is already loaded in the head within ProductMetadata.js
    if (imgUrl === primaryImageUrl) return [];

    return [
      new LinkTag({
        rel: 'preload',
        href: imgUrl,
        id: `preLoadImg ${filteredImage.type}`,
        as: 'image',
        media: `(min-width: ${imageSize}px)`,
        fetchpriority: 'high'
      })
    ];
  };

  useHelmet('decisionEngine.mediaGallery', {}, productMetaDataHandler, []);
};